import { useMutation, useQuery } from '@tanstack/react-query'
import axios, { AxiosError } from 'axios'
import apis from '../../../apis'
import { getJwtToken } from '../../../auth'
import {
  bookMarkedMaterialsQueryApi,
  conversationMaterialsQueryApi,
  experiencedMaterialsQueryApi,
  interestedMaterialsQueryApi,
  materialDetailQueryApi,
  materialsByCategoryIdQueryApi,
  materialsQueryApi,
  selectMaterialGetLesosnInfoQueryApi,
} from '../../../react-query/queryApis'
import { createAxiosTokenConfig } from '../../axios-util'
import { IInterestMaterialData, IMaterialCategoryData } from './types'

export const useMaterials = (isConversation: boolean | { [x: string]: boolean } = false) => {
  const api = isConversation ? conversationMaterialsQueryApi : materialsQueryApi
  return useQuery<any, AxiosError>({
    queryKey: api.getQueryKey(),
    queryFn: api.getQueryFn(),
    // onError: (e) => handleAxiosError(e),
  })
}

export const useInterestedMaterials = () => {
  return useQuery<IInterestMaterialData[], AxiosError>({
    queryKey: interestedMaterialsQueryApi.getQueryKey(),
    queryFn: interestedMaterialsQueryApi.getQueryFn(),

    // onError: (e) => handleAxiosError(e),
  })
}

export const useMaterialsByCategoryId = (categoryId: number | string, options = {}) => {
  const searchParams = { course_large_hashtag_id: categoryId }

  return useQuery<IMaterialCategoryData, AxiosError>({
    queryKey: materialsByCategoryIdQueryApi.getQueryKey({ searchParams }),
    queryFn: materialsByCategoryIdQueryApi.getQueryFn({ searchParams }),

    // onError: (e) => handleAxiosError(e),
    ...options,
  })
}
export const useBookMarkedMaterials = () => {
  return useQuery<any, AxiosError>({
    queryKey: bookMarkedMaterialsQueryApi.getQueryKey(),
    queryFn: bookMarkedMaterialsQueryApi.getQueryFn(),
    // onError: (e) => handleAxiosError(e),
  })
}
export const useExperiencedMaterials = () => {
  return useQuery<any, AxiosError>({
    queryKey: experiencedMaterialsQueryApi.getQueryKey(),
    queryFn: experiencedMaterialsQueryApi.getQueryFn(),

    // onError: (e) => handleAxiosError(e),
  })
}

export const useMaterialDetail = (materialId: number) => {
  const pathParams = { id: materialId }
  console.log(pathParams, 'pathParams')
  return useQuery<any, AxiosError, any>({
    queryKey: materialDetailQueryApi.getQueryKey({ pathParams }),
    queryFn: materialDetailQueryApi.getQueryFn({ pathParams }),

    // onError: (e) => handleAxiosError(e),
    cacheTime: 1000 * 60 * 24,
    staleTime: 1000 * 60 * 24,
  })
}

export const useSelectMaterialGetLesosnInfo = (lessonId: any) => {
  const pathParams = { id: lessonId }

  return useQuery<any, AxiosError, any>({
    queryKey: selectMaterialGetLesosnInfoQueryApi.getQueryKey({ pathParams }),
    queryFn: selectMaterialGetLesosnInfoQueryApi.getQueryFn({ pathParams }),

    // onError: (e) => handleAxiosError(e),
    cacheTime: 1000 * 60 * 24,
    staleTime: 1000 * 60 * 24,
  })
}

export const useCourseDetailShowTooltipV4 = (key: string) => {
  const token = getJwtToken()
  return useQuery<any, AxiosError, any>({
    queryKey: [apis.course.show_tooltip(key)],
    queryFn: async () => {
      const { data } = await axios.get(apis.course.show_tooltip(key), createAxiosTokenConfig(token))
      console.log('QUERY RESPONSE :: ', data)
      return data
    },
    retry: false,
    // onError: (err) => {
    //   console.log({ err })
    // },
  })
}

export const useCourseDetailEditTooltipV4 = () => {
  const token = getJwtToken()
  return useMutation({
    mutationFn: async (body: { key: string; value: boolean }) => {
      await axios.put(apis.course.edit_tooltip(body.key, body.value), null, createAxiosTokenConfig(token))
    },
    // onError: (error) => {
    //   console.log('error', error)
    //   toast(t(s_caf.highlight_list_edit.toast3))
    // },
  })
}
